import React from 'react';
import logo from './static/logo.png';
import './main.css'
//import "./static/css/App.css"
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from './templates/Home.js';
import About from './templates/About.js';
import Blog from './templates/Blog.js';
import Contact from './templates/Contact.js';
import Loader from './templates/Loader_.js';
import Admin from './templates/Admin.js';
import Page404 from './templates/Page404.js';
import instagram from './static/pictures/Social_media_logos/instagram.png';
//import telegram from './static/pictures/Social_media_logos/telegram.png';
import facebook from './static/pictures/Social_media_logos/facebook.png';
import { useEffect, useState } from 'react';
//import email from './static/pictures/Social_media_logos/email.png';
//import whatsApp from './static/pictures/Social_media_logos/whatsApp.png';

function App() {

  const [showPanel, setShowPanel] = useState(false);
  const [loading, setLoading] = useState(true); // Додаємо стан завантаження

  useEffect(() => {
    // Імітуємо завантаження на 2 секунди
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer); // Очистка таймера при демонтажі
  }, []);


  window.addEventListener("scroll", function() {
    let header = document.getElementById("header");
    if (window.scrollY > 50) {
        header.classList.add("shrink");
    } else {
        header.classList.remove("shrink");
    }
  });

  

  window.addEventListener("load", function() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  // let menu_fase = false
  // function menu_click() {
  //   console.log("menu")
  //   let menu = document.getElementById("modal_menu");
  //   menu.style.display = "none";
  //   if (menu_fase === false) {
  //     menu.style.display = "none";
  //     console.log("menu_close")
  //     menu_fase = true
  //   }
  //   else if (menu_fase === true) {
  //     menu.style.display = "block";
  //     menu_fase = false
  //   }
  // }

  
  function togglePanel() {
    setShowPanel(!showPanel);
  }

  if (loading) {
    return <Loader />; // Якщо ще loading == true, показуємо тільки лоадер
  }

  if (window.innerWidth < 600) {
    return (
      <div className='div'>
        <Router>
        <header id='header'>
          <title>Психолог Ганна Лівшиць</title>
          <link rel="preconnect" href="https://fonts.googleapis.com"/>
          <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true"/>
          <link href="https://fonts.googleapis.com/css2?family=Exo+2:ital@0;1&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Kurale&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet"/>
          <Link to="/"><img src={logo} className='logo' alt="Логотип"/></Link>
          <button onClick={togglePanel}></button>
        </header>

        <div className={`slide_in_panel ${showPanel ? 'visible' : ''}`}>
          <button className="close_button" onClick={() => setShowPanel(false)}>×</button>
          <div className="panel_content">
            <div>
              <Link to="/" className='link_mobile' onClick={() => setShowPanel(false)}>Головна</Link>
              <Link to="/about" className='link_mobile' onClick={() => setShowPanel(false)}>Досвід</Link>
              <Link to="/blog" className='link_mobile' onClick={() => setShowPanel(false)}>Блог</Link>
              <Link to="/contact" className='link_mobile' onClick={() => setShowPanel(false)}>Контакти</Link>
            </div>
          </div>
        </div>

        <div className="routes">
          <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/about" element={<About/>} />
            <Route path="/blog" element={<Blog/>} />
            <Route path="/contact" element={<Contact/>} />
            <Route path='/loader' element={<Loader/>}/>
            {/* http://localhost:3000/hello_admin_give_me_anananas */}
            <Route path="/hello_admin_give_me_anananas" element={<Admin/>} /> 

            <Route path="*" element={<Page404/>} />
          </Routes>
        </div>

        <footer>
          <div className='top_footer'>
            <nav className='footer_menu'>
              <Link to="/" className='link_footer'>Головна</Link>
              <Link to="/about" className='link_footer'>Досвід</Link>
              <Link to="/blog" className='link_footer'>Блог</Link>
              <Link to="/contact" className='link_footer'>Контакти</Link>
            </nav>

            <div>
              <a href='https://www.instagram.com/annalivshyts/' className='social_link' target='_blank' rel="noreferrer"><img src={instagram} className='social_media_logo' alt="інстаграм"/></a>
              <a href='https://www.facebook.com/anna.livshyts.3?locale=uk_UA' className='social_link' target='_blank' rel="noreferrer"><img src={facebook} className='social_media_logo' alt="фейсбук"/></a>
            </div>
          </div>
        </footer>
      </Router>
      </div>

    )}
  return (
    <div className='div'>
      <Router>
      <header id='header'>
        <title>Психолог Ганна Лівшиць</title>
        <link rel="preconnect" href="https://fonts.googleapis.com"/>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true"/>
        <link href="https://fonts.googleapis.com/css2?family=Exo+2:ital@0;1&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Kurale&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet"/>
        <Link to="/"><img src={logo} className='logo' alt="Логотип"/></Link>
        <nav className='header_menu'>
          <Link to="/" className='link' id="home">Головна</Link>
          <Link to="/about" className='link' id="about">Досвід</Link>
          <Link to="/blog" className='link' id="blog">Блог</Link>
          <Link to="/contact" className='link' id="contact">Контакти</Link>
        </nav>
      </header>

      <div className="routes">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path='/loader' element={<Loader />}/>
          <Route path="/hello_admin_give_me_anananas" element={<Admin />} /> (//http://localhost:3000/hello_admin_give_me_anananas)
          <Route path="*" element={<Page404 />} />
        </Routes>
      </div>

      <footer>
        <div className='top_footer'>
          <nav className='footer_menu'>
            <Link to="/" className='link_footer'>Головна</Link>
            <Link to="/about" className='link_footer'>Досвід</Link>
            <Link to="/blog" className='link_footer'>Блог</Link>
            <Link to="/contact" className='link_footer'>Контакти</Link>
          </nav>

          <div>
            <a href='https://www.instagram.com/annalivshyts/' className='social_link' target='_blank' rel="noreferrer"><img src={instagram} className='social_media_logo' alt="інстаграм"/></a>
            <a href='https://www.facebook.com/anna.livshyts.3?locale=uk_UA' className='social_link' target='_blank' rel="noreferrer"><img src={facebook} className='social_media_logo' alt="фейсбук"/></a>
          </div>
        </div>
      </footer>
    </Router>
    </div>

)}
    


export default App;
